import React, { useState, useEffect } from "react";

import Breadcrumbs from "../../../components/Breadcrumbs";

import { useTranslation } from "react-i18next";

import Swal from "sweetalert2";

import AuthUser from "../../../components/AuthUser";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "../../../components/Spinner";
import CertificadoFilter from "../Administration/employees/CertificadoFilter";
import CertificadoTable from "../Administration/employees/CertificadoTable";
import CertificadoModal from "../../../components/Administration/employees/CertificadoModal";

const Certificados = () => {

  // eslint-disable-next-line no-unused-vars

  const { http, url_root, user_permissoes, verificarPermissao, getMissao } =
    AuthUser();

  const [certificados, setCertificados] = useState([]);
  const [cursos, setCursos] = useState([]);

  const [filteredCertificados, setFilteredCertificados] = useState([]);

  const [colaboradores, setColaboradores] = useState([]);

  const { t } = useTranslation();

  // State to track whether the "checkgeral" checkbox is checked
  const [loading, setLoading] = useState(false);

  const handleSubmissionSuccess = (certificados) => {
    // Refresh acessos state or trigger any necessary actions
    setCertificados(certificados);
  };

  // Callback function to receive filtered users from UserFilter
  const handleFilterSubmit = (filteredcertificados) => {     
    setFilteredCertificados(filteredcertificados); 
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Chama a função assíncrona getUtilizador()
        await getColaboradores();
        await getCursos();
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }

    }
    // Chama a função fetchData() para iniciar o processo
    fetchData();
  }, []);

  const getColaboradores = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get("/utilizadores/ativados/" + getMissao()?.id);

      setColaboradores(res.data.utilizadores);

      setLoading(false);
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

   const getCursos = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get("/listar-cursos-ativos");

      setCursos(res?.data?.cursos);

      setLoading(false);
      
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  if (verificarPermissao("CARGO", "ver"))
    if (loading)
      return (
        <>
          <Spinner></Spinner>
        </>
      );
    else
      return (
        <>
          (
          <>
            <div className="page-wrapper">
              <div className="content container-fluid">

                <Breadcrumbs
                  maintitle={t("Certificados")}
                  title="Dashboard"
                  subtitle={t("Certificados")}
                  modal="#add_certificado_modal"
                  name={t("Add Certificado")}
                />

                <CertificadoFilter onFilterSubmit={handleFilterSubmit} cursos={cursos} />

                <CertificadoTable
                  certificados={filteredCertificados.length > 0 ? filteredCertificados : certificados}
                  colaboradores={colaboradores} 
                />
                
                <CertificadoModal onSubmissionSuccess={handleSubmissionSuccess} colaboradores={colaboradores} />

              </div>
            </div>{" "}
          </>
          );{" "}
        </>
      );
  else
    return (
      <>
        <div className="page-wrapper cardhead">
          <div className="content ">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">SEM PERMISSÃO</h3>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">
                      <i className="fa fa-times-circle text-danger"></i>&nbsp;
                      OPERAÇÃO NÃO AUTORIZADA
                    </h4>
                  </div>
                  <div className="card-body">
                    <p>
                      Esta operação não é autorizada para o seu nivel de acesso
                      ao sistema, por favor contacte o administrador do sistema.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
};

export default Certificados;
